import { t } from '../../../../../../common/i18n.js'
import { Language } from '../../../../../../common/types/i18n.js'

interface Company {
    id: number
    name: string
    reg_code: string | null
    standard_day_hours: number
}

export interface GeneralSectionProps {
    lang: Language
    companies: Company[]
}

export const GeneralSection = ({ lang, companies }: GeneralSectionProps) => {
    const s = t.portal.settings

    return (
        <div>
            <div className="portal-settings__section-header">
                <h3 className="portal-settings__section-title">{s.general.companyInfo(lang)}</h3>
            </div>
            {companies.length === 0 ? (
                <div className="portal-settings__section-empty">{s.general.noCompanies(lang)}</div>
            ) : (
                <div className="portal-settings__company-cards">
                    {companies.map((c) => (
                        <div key={c.id} className="portal-settings__company-card">
                            <h4>{c.name}</h4>
                            {c.reg_code ? (
                                <p>
                                    {s.general.regCode(lang)}: {c.reg_code}
                                </p>
                            ) : null}
                            <p>
                                {s.general.standardDayHours(lang)}: {Number(c.standard_day_hours)}h
                            </p>
                        </div>
                    ))}
                </div>
            )}

            {/* M9.2: NotificationSettingsInfo — static informational section */}
            <div className="portal-settings__notification-info">
                <div className="portal-settings__section-header">
                    <h3 className="portal-settings__section-title">
                        {s.general.notificationsTitle(lang)}
                    </h3>
                </div>
                <p className="portal-settings__notification-intro">
                    {s.general.notificationsInfo(lang)}
                </p>
                <ul className="portal-settings__notification-list">
                    <li>{s.general.notifLeaveRequest(lang)}</li>
                    <li>{s.general.notifLeaveApproved(lang)}</li>
                    <li>{s.general.notifBirthday(lang)}</li>
                    <li>{s.general.notifProbation(lang)}</li>
                    <li>{s.general.notifAnniversary(lang)}</li>
                </ul>
            </div>
        </div>
    )
}
